<template>
  <div :style="{height:height,overflow:'auto',padding:'8px 30px 2px 30px','background-color':'#e9ebe9',border:'solid 1px #ddd'}">
    <el-row ref="selUserRow" :gutter="20" v-if="actions.indexOf('flowreaded')<0 && actions.indexOf('flowcomplete')>=0" :style="{'margin-left': marginLeft,'text-align':'left'}">
      <el-col :span="8" style="width:300px;">
        <div class="demo-input-suffix">
          {{$lang('流转到')}}：
          <el-select v-model="selectedFlowId" ref="flowsSelect" style="width:calc(100% - 68px)" :placeholder="$lang('请选择流向')" @change="flowChange">
            <el-option
              v-for="flow in mixFlows"
              :key="flow.id"
              :label="flow.name"
              :value="flow.id">
            </el-option>
          </el-select>
        </div>
      </el-col>
      <el-col  style="width:calc(100% - 310px);padding-left: 0px;">
        <el-button style="vertical-align: top;" class="hg_form_btn_cls" v-if="!isExtraFlowActive && !isOverFlow" :loading="selUserLoading"  type="default" icon="fa fa-user" @click="selectUser">{{$lang("选择人员")}}</el-button>
        <el-button style="vertical-align: top;" class="hg_form_btn_cls" v-if="isExtraFlowActive && selectedFlow.button" type="info" icon="fa fa-user" @click="extraFlowButtonClick">{{selectedFlow.button.text}}</el-button>
        <!--<el-tag
          v-for="user in selectedUsers"
          :key="user.id"
          @close="deleteUser(user)"
          closable
        >{{user.name}}</el-tag>-->
        <div  class="recipient-flow-area-box">
          <span :key="user.id" v-for="user in selectedUsers" class="person-item"><span style="color:#004ecc">{{user.name}}</span>&nbsp;<a class="fa fa-times" @click="deleteUser(user)"></a></span>
          <el-autocomplete v-if="!isExtraFlowActive && !isOverFlow"
                           ref="searchUser"
            popper-class="flow-action-area-autocomplete"
            v-model="selUserModel"
            :fetch-suggestions="searchHandleTaskData"
            :placeholder="$lang('请输入内容')"
            style="width: 160px"
            @select="setSelCandidateUser">
            <template  slot-scope="scope">
              <div class="name">{{scope.item.name}}<span class="addr" v-if="scope.item.departmentFullName">({{scope.item.departmentFullName}})</span></div>
            </template>
          </el-autocomplete>
        </div>
      </el-col>
    </el-row>
    <el-row :gutter="20" style="margin-top:5px;text-align: center;">
      <el-col :span="24">
        <!--primary icon="fa fa-share-alt"   icon="fa fa-reply" icon="fa fa-file-text-o" icon="fa fa-save" -->
        <el-button type="default" class="hg_form_btn_cls" :loading="submitLoading" v-if="actions.indexOf('flowcomplete')>=0" @click="submit">{{$lang("流转")}}</el-button>
        <el-button type="default" class="hg_form_btn_cls" v-if="actions.indexOf('flowreject')>=0" @click="reject">{{$lang("退回")}}</el-button>
        <el-button type="default" class="hg_form_btn_cls" v-if="actions.indexOf('flowreaded')>=0" @click="flowreaded">{{$lang("阅毕")}}</el-button>
        <el-button type="info" class="hg_form_btn_cls" :loading="saveLoading" v-if="actions.indexOf('flowsave')>=0" @click="formSave">{{$lang("保存")}}</el-button>
        <el-button type="default" class="hg_form_btn_cls" v-if="actions.indexOf('flowplanned')>=0" @click="flowplanned">{{$lang("拟办")}}</el-button>
        <el-button type="default" class="hg_form_btn_cls" v-if="actions.indexOf('flowtransmit')>=0 && canTransmit" @click="flowtransmit">{{$lang("转办")}}</el-button>

        <template v-for="item in footerItems" style="display: inline-block;">
          <template v-if="!item.noShow">
            <template v-if="item.handler && item.text">
              <el-button type="default" class="hg_form_btn_cls" :icon="item.icon" @click="item.handler">{{item.text}}</el-button>
            </template>
            <template v-else>
              <component :is="item"></component>
            </template>
          </template>
        </template>
      </el-col>
    </el-row>
    <el-dialog
      v-for="flow in flows"
      :key="flow.id"
      :title="$lang('选择人员')"
      :visible="dialogVisible && selectedFlowId===flow.id"
      @opened="dialogOpened"
      @open="dialogOpen"
      width="500px"
      :show-close="false"
      append-to-body
    ><div :style="{'max-height':maxHeight,overflow:'auto'}">
      <mw-complete-tree v-if="flow.userTreeVisible"
                        :url="'/rest/process/task/flow/'+ form.taskId + '/' + flow.id"
                        :defaultParams="processTaskLoadUser(flow,{returnTree:flow.options.returnTree})"
                        :autoSelectSingle="false" :ref="flow.id"
                        :businessId='form.businessId' :batchId="form.batchId" :activityId="flow.activityId"
                        :async="true" :multiple="!!flow.options.multipleUnit"
                        :expandedFirst="true" :mulNodeNotExpand="true" :type="flow.type" :flowCount="flowCount">
      </mw-complete-tree>
    </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="setSelectUsers(flow)">{{$lang("确 定")}}</el-button>
        <el-button @click="dialogVisible = false">{{$lang("取 消")}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import mwCompleteTree from '@/common/components/public-dialog/tree/index.vue'

  export default {
    components: {
      mwCompleteTree
    },
    props: {
      form: Object,
      height: String,

    },
    data() {
      return {
        maxHeight:($(window).height()-225)+'px',
        canTransmit:(window.$Env && $Env.flowShowTransmitBtn ? true : false),
        marginLeft:(window.$Env && $Env.formFlowAreaMarginLeft || "0")+"px",
        selectedFlowId: "",
        flows: [],
        extraFlows:[], //外部传的自定义“流向”,[{name:"自定义名字",button:{text:"选择",handler:fn}}]
        selectedUsers: [],
        selectedUserIds:[],
        selUserModel:'',
        dialogVisible: false,
        isAppendIFrame:false,
        mulSel:false,
        flowCount: 0,
        loading:false,
        candidateBmIds:[],
        flowCandidateData:[],
        loadedSearchUser:false,
        curSelFlowData:[],
        footerItems:[],
        actions:[],
        autoLoadSingleUser:false,
        submitLoading:false,
        selUserLoading:false,
        saveLoading:false
      }
    },
    mounted() {
      let me = this;
      if (me.form) {
        let unwatch=me.form.$watch("buttons",{
          handler(btns) {
            if (!_.isEmpty(btns)) {
              me.actions=_.map(btns,"action")
            } else {
              me.actions=[];
            }
          },
          immediate: true
        });
        me.form.$once("hook:beforeDestroy", () => {
          unwatch();
        });
        let doRenderTask=function(){
          me.form.renderTaskFormFlowTip(function (flows) {
            if (flows) {
              me.flows = flows;
              me.flowCount = flows.length;
              me.selectedFlowId = me.flows[0] && me.flows[0].id;
              me.flowChange();
              me.$emit("flowReady");
            }
          });
        };
        me.form.$on("beforeRender",function(){
           if(me.form.isNotifyTask()){
             me.form.flowAreaBottomSelRowHeight = 0;
             return;
           }
           doRenderTask();
        })
      }
    },
    methods: {
      flowChange() {
        this.selectedUsers = [];
        this.candidateBmIds = [];
        this.flowCandidateData = [];
        this.curSelFlowData = [];
        this.loadedSearchUser = false;
        if (this.isExtraFlowActive) {
          if (this.selectedFlow.onActive) {
            this.selectedFlow.onActive.call(this,users=>this.selectedUsers=users);
          }
        }
        let params = {};
        this.$emit("flowChange", this,this.selectedUsers,params);
        if(params.returnFalse !== false ){
          if (this.isOverFlow) {
            if(this.form.taskId){
              this.loadSingleUsers(); //运转办结要显示发送人的名称yhq 2019-04-13
            }else{
              this.selectedUsers=[{name: "<流程结束>", id: "<流程结束>"}]
            }
          }else{
            if(!this.isExtraFlowActive && this.form.taskId){
              this.loadSingleUsers(); //选择流向自动加载用户
            }
          }
        }
      },
      formSave(){
        let me=this;
        me.saveLoading=true;
        if (!me.form.$newForm.isValid(true)) {
          me.saveLoading = false;
          return;
        }
        me.form.startProcess((data, err) => {
          me.saveLoading = false;
          if(!err) {
            PF.message($lang("表单数据保存成功")+"!");
          }
        });
      },
      reject() {
        PF.action.flowreject(this.form.$newForm);
      },
      flowreaded() {
        PF.action.flowreaded(this.form.$newForm);
      },
      flowplanned(){
        PF.action.flowplanned(this.form.$newForm);
      },
      flowtransmit(){
        PF.action.flowtransmit(this.form.$newForm);
      },
      deleteUser(user) {
        let index = this.selectedUsers.indexOf(user);
        this.selectedUsers.splice(index, 1);
      },
      searchHandleTaskData: _.debounce(function (query,cb){
        let me = this;
        if (query) {
          this.loading = true;
          if (me.form.taskId) {
            me.doFilterCandidateData(query,cb);
          } else {
            if (!me.form.$newForm.isValid(true)) {
              this.loading = false;
              return;
            }
            me.form.startProcess((d,err) => {
              me.loadSingleUsers(function(){
                me.doFilterCandidateData(query,cb);
              });
            });
          }
        } else {
          cb([]);
        }
      },200,{
        'leading': true,
          'trailing': false
      }),
      doFilterCandidateData(qcon,cb){
        let me = this;
        if(!qcon){
          cb([]);
          return;
        }
        me.doSearchHandleTaskData(function(data){
          if(!qcon)cb([]);
          let ds = _.filter(data,function(d){ return d.name.toLowerCase().indexOf(qcon.toLowerCase()) > -1;}) || [];
          cb(ds);
        });
      },
      setSelCandidateUser:function(row, event, column){
        let me = this;
        let flow = me.getSelectedFlow();
        if(!flow) return;
        if(!flow.options.multipleUnit){
          me.selectedUsers = [row];
          return;
        }
        let r = _.find(me.selectedUsers,function(d){return d.id==row.id});
        if(!r){
          me.selectedUsers.push(row);
        }
      },
      doSearchHandleTaskData(callback){
        let me = this;
        if(me.loadedSearchUser){
          me.loading = false;
          callback(me.flowCandidateData);
          return;
        }
        let flow = me.getSelectedFlow();
        if(!flow){
          return ;
        }
        if(flow.type=="startSubProcess"){
          me.mwApi.process.listPlannedSubByBatchIdAndActivityId(me.form.batchId, flow.activityId).then(v => {
            let removeIds  = [];
            if (v.result) {
              v.result.forEach(v1 => {
                removeIds.push(v1.id);
              })
            }
            //部门运转
            if(flow.options.sendUnit=='DEP'){
              var ds = _.filter(me.curSelFlowData,function(d){ return removeIds.indexOf(d.id) == -1;}) || [];
              me.loading = false;
              me.flowCandidateData = ds;
              me.loadedSearchUser = true;
              callback(me.flowCandidateData);
            }else{
              //人员运转
              let qp = {taskId:me.form.taskId,flowId:me.selectedFlowId};
              qp.candidateBmIds = me.candidateBmIds;
              PF.invoke("s:process.srv.searchHandleTaskData",qp).then(function(ret){
                me.loading = false;
                var ds = _.filter(ret.result,function(d){ return removeIds.indexOf(d.id) == -1;}) || [];
                me.flowCandidateData = ds;
                me.loadedSearchUser = true;
                callback(ds);
              }).catch(()=>{
                me.loading = false;
              })
            }
          })
        }else{
          let qp = {taskId:me.form.taskId,flowId:me.selectedFlowId};
          qp.candidateBmIds = me.candidateBmIds;
          PF.invoke("s:process.srv.searchHandleTaskData",qp).then(function(ret){
            me.loading = false;
            me.flowCandidateData = ret.result || [];
            me.loadedSearchUser = true;
            callback(me.flowCandidateData);
          }).catch(()=>{
            me.loading = false;
          })
        }
      },
      getSelectedFlow(){
        return _.find(this.mixFlows, {id: this.selectedFlowId})
      },
      selectUser() {
        let me = this;
        let flow = me.getSelectedFlow();
        if (flow) flow.userTreeVisible = true;
        if (me.form.taskId) {
          me.dialogVisible = true;
        } else {
          if (!me.form.$newForm.isValid(true)) {
            return;
          }
          me.selUserLoading = true;
          me.form.startProcess((d,err) => {
            me.selUserLoading = false;
            if(!err) {
              me.dialogVisible = true;
            }
          });
        }
      },
      dialogOpen(){
        if($(".v-modal").length > 0){
          this.appendDialogIframe();
        }
      },
      dialogOpened(){
        let me = this;
        if($(".v-modal").length > 0 ) {
          if($(".v-modal").find("iframe").length === 0){
            me.appendDialogIframe();
          }
          return;
        }
        MW.test(()=>{
          if($(".v-modal").length > 0){
            return true;
          }
        },()=>{
          me.appendDialogIframe();
        },5);//win7的需要settimeout
      },
      appendDialogIframe(){
        //加上一个iframe,让控件无法遮住对话框
        $(".v-modal").append($("<iframe width='100%' heigh='100%''></iframe>").css({
          width: '100%',
          height: '100%',
          border: '0px',
          position: "absolute"
        }));
      },
      setSelectUsers(flow) {
        let me = this;
        let tree = me.$refs[flow.id][0];
        //let nodes1 = tree.getSelected();
        let nodes=tree.getSelectNodes(true);
        me.selectedUsers = _.isArray(nodes) ? nodes : [nodes]
        me.dialogVisible=false;
      },
      processTaskLoadUser(flow,params){
        this.form.$newForm.fireEvent("flowseltaskhandleuser",flow,params);
        return params;
      },
      loadSingleUsers(params,callback) {
        let me=this;
        if (!me.selectedFlowId) {
          //已经在自动调用了。
          //me.$once("flowReady",()=>me.loadSingleUsers());
          return;
        }
        if($.isFunction(params)){
          callback = params;
          params = {};
        }else{
          params = params || {};
        }
        let doload = function(){
          $.ajax({
            url:`/rest/process/task/flow/${me.form.taskId}/${me.selectedFlowId}`,
            data:params,
            success:function(tree){
              function getDeepNode(node) {
                if(!node || !node.children) return node;
                return getDeepNode(node.children[0])
              }
              function isSingleFlow(tree){
                if(!tree || tree.length!==1)return false;
                if(!tree[0].children || tree[0].children.length===0){
                  return !tree[0].hasChild
                }else{
                  return isSingleFlow(tree[0].children)
                }
              }
              me.curSelFlowData = tree;
              me.processCandidateBmIds(tree);
              if (isSingleFlow(tree)) {
                me.selectedUsers=[getDeepNode(tree[0])];
              }
              if(_.isFunction(callback)){
                callback(tree);
              }
            }
          });
        }
        if(me.form.$newForm.fireEvent("beforeflowtaskuserload",me.getSelectedFlow(),params,doload)===false){
          return false;
        }
        doload();
      },
      processCandidateBmIds(tree){
        let me = this;
        me.candidateBmIds = [];
        if(tree){
          function processBmIds(ds){
            if(ds && ds.length > 0){
              _.each(ds,function(d) {
                if(d.hasReal && d.hasChild){
                  me.candidateBmIds.push(d.id);
                }
                processBmIds(d.children);
              });
            }
          }
          processBmIds(tree);
        }
      },
      submit: _.debounce(function () {
        let me = this;
        if (!me.form.$newForm.isValid(true)) {
          return;
        }
        if (!me.selectedFlowId) {
          PF.message("info", $lang("未获取到符合条件的流向信息"));
          return;
        }
        if (_.isEmpty(me.selectedUsers)) {
          PF.message("info", $lang("请先选择人员"));
          return;
        }
        me.submitLoading=true;
        me.form.startProcess((d, err) => {
          me.submitLoading=false;
          if (!err) {
            if (me.isExtraFlowActive) {
              if (me.selectedFlow.onSubmit) {
                me.selectedFlow.onSubmit.call(me,me.selectedFlow,me.selectedUsers,d);
              }
              return;
            }
            if (me.form.$newForm.fireEvent("beforecomplete", me.form,me.form, continuation.bind(this)) === false) {
              return false;
            }
            continuation();
            function continuation(){
              me._submit();
            }
          }
        });
      }, 1000, {
        'leading': true,
        'trailing': false
      }),
      _submit() {
        let me = this;
        if (!me.selectedFlowId) {
          PF.message("info", $lang("未获取到符合条件的流向信息"));
          return;
        }
        if (_.isEmpty(me.selectedUsers)) {
          PF.message("info", $lang("请先选择人员"));
          return;
        }
        function doCommit(params) {
          me.form.$newForm.fireEvent("beforedocomplete", params);
          me.submitLoading=true;
          me.mwApi.process.batchCommit(params).then((res) => {
            me.submitLoading=false;
            var data = res.result;
            if (data && !data.success) { //提交意见检查
              if (data.errorType == 'comment') {
                if (data.errorCode == 'comment_check_stop') {
                  PF.message('info', $lang('您还没有填写意见,请填写意见'));

                  return;
                } else if (data.errorCode == 'comment_check_remind') {
                  PF.confirm($lang('您还没有填写意见,您确认是要继续完成？'), $lang('提示'), {type: 'warning'}).then(() => {
                    params['$directSave'] = true;
                    doCommit(params);
                  }).catch(() => {

                  });
                  return;
                }
              } else {
                var errorMsg = '';
                if (data.errorMsg) {
                  errorMsg = '[' + $lang('错误信息') + ':' + data.errorMsg + ']';
                }
                PF.message('info', $lang('完成失败') + errorMsg + '!');
                return;
              }
            } else {
              if (me.form.$newForm.fireEvent("aftercomplete", params,res) === false) {
                return false;
              }
              me.form.formActionComplete();
            }
          }).catch(() => {
            me.submitLoading=false;
          });
        }
        let flowData = me.getSelectedFlow();
        if (me.selectedFlowId && me.selectedUsers.length===0) {
          if (flowData.activityId === 'end') {//下一个节点是结束节点
            let params = {};
            params.type = "complete";
            //params.isAddAttention = me.isAddAttention;
            params.taskId = me.form.taskId;
            params.appId = me.form.appId;
            params.formId = me.form.formId;
            params.formKey = me.form.formKey;
            // params.entityId = me.form.entityId;
            params.businessId = me.form.businessId;
            params.activities = [{flowId: flowData.id, activityId: flowData.activityId}];
            if (me.form.comment) {
              params.$comment = [{id: me.form.commentId, content: me.form.comment, category: me.form.commentCategory}];
            }
            params.formOpenSource = me.params.formOpenSource;

            doCommit(params);
          } else {
            PF.message("info", $lang("请先选择办理人员"));
          }
        } else {
          let activity={};
          activity.flowId=flowData.id;
          activity.activityId=flowData.activityId;
          activity.type=flowData.type;
          activity.options=flowData.options;
          let items=[];
          //部门运转有问题，yhq2019-04-13
          if(flowData.type=="startSubProcess" && activity.options.activityUnit=='group'){
            $.each(me.selectedUsers,function(i,d){
                var uitem={group:d.id};
                uitem.users = [];
                _.each(d.identities,function(u){
                    uitem.users.push({id:u.id});
                })
                items.push(uitem)
            })
          }else{
            _(me.selectedUsers).groupBy("parentId").each((users,parentId)=>{
              if(flowData.options.singleDepartmentRecord!=="true"){
                users.forEach(u=>{
                  items.push({
                    group:parentId,
                    users:[{id:u.id.split("_").pop()}]
                  });
                });
              }else{
                items.push({
                  group:parentId,
                  users:users.map(u=>{return {id:u.id.split("_").pop()}})
                })
              }
            });
          }
          activity.items=items;
          let params = {};
          params.type = "complete";
          //params.isAddAttention = me.isAddAttention;
          params.taskId = me.form.taskId;
          params.appId = me.form.appId;
          params.formId = me.form.formId;
          params.formKey = me.form.formKey;
          //params.entityId = me.form.entityId;
          params.businessId = me.form.businessId;
          params.activities = [activity];
          params.formOpenSource = me.form.formOpenSource;
          doCommit(params);
        }
      },
      extraFlowButtonClick() {
        if(!this.isExtraFlowActive)return;
        let fn=this.selectedFlow.button.handler;
        fn.call(this,(users)=>{
          this.selectedUsers=users;
        });
      }
    },
    watch:{
      selectedUsers(newVal,oldVal) {
        if(newVal && oldVal && newVal.length==oldVal.length && newVal.length===0){
          return;
        }
        setTimeout(()=>{
          let selUserRowObj = this.$refs.selUserRow;
          if(selUserRowObj){
            let height = $(selUserRowObj.$el).height();
            if(height > 200){
              height = 200;
            }
            this.form.flowAreaBottomSelRowHeight = height;
          }
        },50);
      }
    },
    computed:{
      mixFlows(){
        let flows = this.flows.concat(this.extraFlows)
        if(flows && flows.length > 1){
          flows.sort(function(ao, bo) {
             let a = ao.sn || 0;
             let b = bo.sn || 0;
             return a - b;
          });
        }
        return flows;
      },
      isExtraFlowActive(){
        return this.selectedFlowId && _.findIndex(this.extraFlows,f=>f.id===this.selectedFlowId)>=0
      },
      isOverFlow() {
        return this.selectedFlow && this.selectedFlow.activityName==="结束"
      },
      selectedFlow() {
        return this.getSelectedFlow()
      }
    }
  }
</script>
<style >
  .recipient-flow-area-box .el-input{
    width:100%;
  }
  .recipient-flow-area-box .el-input__inner{
    border:none;
  }
  .el-autocomplete-suggestion.flow-action-area-autocomplete{
    width: 260px !important;
  }
  .el-autocomplete-suggestion.flow-action-area-autocomplete li .addr {
    font-size: 12px;
    color: #b4b4b4;
    word-wrap: break-word;
    word-break: normal;
  }
</style>
<style scoped>
  div >>> .el-tag + .el-tag {
    margin-left: 10px;
  }
  .recipient-flow-area-box{
    display:inline;
    width: calc(100% - 116px);
    /*border-bottom:1px solid #ddd;*/
    line-height:30px;
    /*background: #FFF;*/
  }
  .recipient-flow-area-box .person-item {
    color: #444;
    padding: 0 10px;
    background:rgb(240,240,240) ;
    background-repeat: repeat-x;
    border: 0px solid #bbb;
    filter: none;
    -moz-border-radius: 12px;
    -webkit-border-radius: 12px;
    border-radius: 5px;
    margin: 0 5px 3px 0;
    display: inline-block;
  }
  .recipient-flow-area-box .person-item:hover {
    background: #ddd;
    color: #00438a;
    border: none;
    filter: none;
  }


</style>



// WEBPACK FOOTER //
// src/common/components/extend/form/src/flow-action-area.vue